import React, { useState, useEffect, useRef } from "react";
import "./Invoice.scss";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useParams } from "react-router-dom";
import axios from "axios";

const Invoice = () => {
  const { id } = useParams();
  const pdfRef = useRef();

  const tokena = localStorage.getItem("raer_token");
  const userId = localStorage.getItem("raer_id");

  const downloadPDF = () => {
    const input = pdfRef.current;
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4", true);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;
      const imgY = 0;
      pdf.addImage(
        imgData,
        "PNG",
        imgX,
        imgY,
        imgWidth * ratio,
        imgHeight * ratio
      );
      pdf.save("invoice.pdf");
    });
  };

  const [userAddress, setUserAddress] = useState([]);
  const [order, setOrder] = useState([]);

  const fetchOrder = async () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getOrderById/${id}`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status) {
          setOrder(response.data.data);
        }
        if (response?.data?.status) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };
  useEffect(() => {
    fetchOrder();
  }, [id]);

  console.log("))))))))))))))))))))))", order);

  return (
    <div>
      <div className="I-main">
        <div className="I-outer" ref={pdfRef}>
          <div className="I-inner">
            <div className="top row">
              <div className="top-part-1 col-6">
                <h5>Buyer Information</h5>

                <div>
                  <p>
                    <span>Name:</span> {order?.billing_details?.fullName}
                  </p>
                  <p>
                    <span>Email:</span> {order?.billing_details?.email}
                  </p>
                </div>

                <p>
                  <span>Phone:</span> {order?.billing_details?.phone}
                </p>
              </div>
            </div>
            <div className="mid">
              <div className="mid-outer">
                <div className="mid-inner">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Serial No.</th>
                        <th>Product Name</th>
                        <th>HSN/SAC</th>
                        <th>Quantity</th>
                        <th>Price (INR)</th>
                        <th>Total Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {order?.products?.map((product, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <img
                              src={product?.productId?.image[0]}
                              alt={product?.productId?.productName}
                              className="img-fluid"
                              style={{ maxWidth: "50px" }}
                            />
                            {product?.productId?.productName}
                          </td>
                          <td>{product?.productId?.hsnSac}</td>{" "}
                          {/* Assuming HSN/SAC field is available */}
                          <td>{product?.count}</td>
                          <td>{product?.productId?.price}</td>
                          <td>{product?.productId?.price * product?.count}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="5">Shipment Charge</td>
                        <td>{order?.shipping_cost}</td>
                      </tr>
                      <tr>
                        <td colSpan="5">Total Gross</td>
                        <td>{order?.total_amount}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="bottom">
              <div className="bottom-outer">
                <div className="bottom-inner">
                  <div className="head">
                    <h5>Shipping From:</h5>
                  </div>
                  <div className="body">
                    {/* <p>
                      204, Princess Business SkyPark, Opp. Orbito Mall, A.B.
                      Road, Indore
                    </p> */}
                    <p>
                      <span>Phone: </span>+91 9981914176
                    </p>
                    <p>
                      <span>Email: </span>Raerofficialclothing@gmail.com
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="download-button d-flex align-items-center justify-content-center ">
              <button class="btn btn-primary" onClick={downloadPDF}>
                Download
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invoice;
